import { sendGTagRetail } from "./Analytics";
import ApplicationState from "./ApplicationState";

export default function googleRemarketing()
{
    let eventType = ApplicationState.commonStorage.get('google-remarketing-event-type');

    if (eventType === null) {
        return;
    }

    if (eventType === 'view_item_list' || eventType === 'view_search_results') {
        processItemList(eventType);
    }
}

let processItemList = function (eventType: string) {
    document.body.addEventListener('product-variations-loaded', () => {
        let ids = [];
        let total = 0;

        document.querySelectorAll('.js-product-item').forEach(itemNode => {
            let item = itemNode as HTMLElement;

            if (ids.length >= 6) {
                return;
            }

            let price = item.querySelector('[itemprop="price"]');

            if (price !== null && price.getAttribute('content')) {
                total += Number(price.getAttribute('content'));
            }

            ids.push(item.dataset.productId);
        });

        sendGTagRetail(eventType, ids, total);
    });

    document.body.addEventListener('product-variations-switched', (evt) => {
        let e     = evt as CustomEvent;
        let price = Number(e.detail.price.price);

        sendGTagRetail(eventType, [e.detail.id], isNaN(price) ? undefined : price);
    });
}
